import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {  MatDatepickerModule, MatNativeDateModule } from '@angular/material';


import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LoginService } from './services/login.service';
import { AdminService } from './services/admin.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { UsersComponent } from './users/users.component';
import {MatTableModule,MatFormFieldModule,MatInputModule,MatRippleModule,MatButtonModule} from '@angular/material';
import {CdkTableModule} from '@angular/cdk/Table';
import { SetroleComponent } from './setrole/setrole.component';
import { SelfAppraisalComponent } from './self-appraisal/self-appraisal.component';
import { AppraisalService } from './services/appraisal.service';
import { SelfAppraisalListComponent } from './self-appraisal-list/self-appraisal-list.component';
import { AssignL2Component } from './assign-l2/assign-l2.component';
import { AssessmentL2Component } from './assessment-l2/assessment-l2.component';
import { NumberAssessmentL2Component } from './number-assessment-l2/number-assessment-l2.component';
import { AssessmentL3Component } from './assessment-l3/assessment-l3.component';
import { AssessmentL4Component } from './assessment-l4/assessment-l4.component';
import { NusListL3Component } from './nus-list-l3/nus-list-l3.component';
import { SetNsuL2Component } from './set-nsu-l2/set-nsu-l2.component';
import { NusAssessmentL2Component } from './nus-assessment-l2/nus-assessment-l2.component';
import { ChangePwdComponent } from './change-pwd/change-pwd.component';
import { ViewPrintComponent } from './view-print/view-print.component';
import { DataTablesModule } from 'angular-datatables';
import { AdminChgpwdComponent } from './admin-chgpwd/admin-chgpwd.component';
import {Nl2BrPipeModule} from 'nl2br-pipe';
import { SelfAppraisalArchieveComponent } from './self-appraisal-archieve/self-appraisal-archieve.component';



var routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'userList',
    component: UsersComponent
  }
  ,
  {
    path: 'setrole/:employee_code',
    component: SetroleComponent
  },
  {
    path: 'selfAppraisal',
    component: SelfAppraisalComponent
  }
  ,
  {
    path: 'selfAppraisalArchieve',
    component: SelfAppraisalArchieveComponent
  }
  ,
  {
    path: 'selfAppraisalAssign',
    component: SelfAppraisalListComponent 
  } ,
  {
    path: 'assignL2/:employee_code/:form_id',
    component: AssignL2Component 
  }
  ,
  {
    path: 'assessmentL2/:form_id',
    component: AssessmentL2Component 
  }
   ,
  {
    path: 'number-assessmentL2/:form_id',
    component: NumberAssessmentL2Component 
  }
  ,
  {
    path: 'assessmentL3/:form_id',
    component: AssessmentL3Component 
  }
  ,
  {
    path: 'assessmentL4/:form_id',
    component: AssessmentL4Component 
  }
   ,
  {
    path: 'nsuAssignL2',
    component: NusListL3Component 
  },
  {
    path: 'setNsuL2/:employee_code',
    component: SetNsuL2Component 
  },
  {
    path: 'nusAssessmentL2/:employee_code',
    component: NusAssessmentL2Component 
  }
  ,
  {
    path: 'change_pwd',
    component: ChangePwdComponent 
  }
  ,
  {
    path:'viewPrintForm/:form_id/:level',
    component: ViewPrintComponent 
  }
 ,
  {
    path:'admin_chgpwd/:employee_code',
    component: AdminChgpwdComponent 
  }
];


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    HeaderComponent,
    FooterComponent,
    UsersComponent,
    SetroleComponent,
    SelfAppraisalComponent,
    SelfAppraisalListComponent,
    AssignL2Component,
    AssessmentL2Component,
    NumberAssessmentL2Component,
    AssessmentL3Component,
    AssessmentL4Component,
    NusListL3Component,
    SetNsuL2Component,
    NusAssessmentL2Component,
    ChangePwdComponent,
    ViewPrintComponent,
    AdminChgpwdComponent,
    SelfAppraisalArchieveComponent
  ],
  imports: [
    BrowserModule,RouterModule.forRoot(routes), HttpModule, FormsModule,  ReactiveFormsModule, MatTableModule,MatFormFieldModule,MatInputModule,MatRippleModule,MatButtonModule,
    CdkTableModule,MatDatepickerModule, MatNativeDateModule,BrowserAnimationsModule,NoopAnimationsModule,DataTablesModule,Nl2BrPipeModule
   
  ],
  providers: [LoginService,AdminService,AppraisalService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts